import React, { useState } from "react";
import newsletter from "../../images/newsletter.svg";

const EmailSubcription = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // simple email regex
  const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value || isValidEmail(value)) {
      setError("");
    } else {
      setError("Enter a valid e-mail address to continue");
    }
  };

  const handleSubmit = async () => {
    if (!isValidEmail(email)) {
      setError("Enter a valid e-mail address to continue");
      return;
    }

    try {
      setLoading(true);
      setError("");

      // DEMO SERVER (replace later)
      await fetch("https://jsonplaceholder.typicode.com/posts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      alert("Subscribed successfully!");
      setEmail("");
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col-reverse py-12 emailSubscriptionBg justify-between items-center w-full md:flex-row px-4 md:px-8">
      <div className="w-full md:w-6/12 flex flex-col">
        <div>
          <p className="text-gray-400 text-xl md:text-4xl font-bold mb-2">
            Stay on top of crypto. All the time, any time.
          </p>
          <p className="md:font-normal text-sm text-gray-500">
            Please keep me updated by email with the latest crypto news,
            research findings, reward programs, event updates, coin listings and
            more information from Pittsburghprivateadvisors.com.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-start  items-start mt-4 w-full">
          <div className="w-full flex-col flex ">
            <input
              type="email"
              value={email}
              onChange={handleChange}
              placeholder="Enter your e-mail address"
              className={`w-full md:py-4 py-3 rounded text-sm px-4 shadow outline-none
                ${error ? "bg-red-100 border border-red-400" : "bg-gray-200"}`}
            />

            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
          </div>
          <div className="md:w-2/12 w-full  flex-col flex ">
            {" "}
            <button
              onClick={handleSubmit}
              disabled={loading}
              className="bg-blue-600  hover:bg-blue-700
    active:bg-blue-800
    focus:bg-blue-600
    focus-visible:bg-blue-600
    focus:outline-none
    focus-visible:outline-none font-bold md:ml-4 md:py-4 w-full  py-3 rounded text-sm px-4 shadow text-white md:mt-0 mt-4 disabled:opacity-50"
            >
              {loading ? "Submitting..." : "Subscribe"}
            </button>
          </div>
        </div>
      </div>

      <div className="w-full md:w-4/12 mb-4 md:mb-0">
        <img src={newsletter} alt="Newsletter" />
      </div>
    </div>
  );
};

export default EmailSubcription;
